/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';
import { CoreAppConfigs } from '@core/configs/app.configs';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-layout-footer',
    templateUrl: './footer.component.html',
})
export class LayoutFooterComponent {

    public appNameDesktop = CoreAppConfigs.NAME_DESKTOP + ' - ' + CoreAppConfigs.VERSION;

    constructor(private utility: UtilsService) {

    }

    public downloadManuale() {
        this.utility.downloadManuale().subscribe();
    }

}
